export default {
  menu: {
    report: 'Zestawienie',
    reports: 'Zestawienia',
    dataDownload: 'Trwa pobieranie danych. Proszę czekać...',
  },
  filter: {
    invoiceType: 'Typ faktury',
    invoiceStatus: 'Status faktury',
    dateSale: 'Data sprzedaży',
    datePurchase: 'Data zakupu',
    dateInvoices: 'Data wystawienia',
    yearGive: 'Proszę podać rok.',
    rangeMonth: 'Zakres miesięcy',
    hideInvoiced: 'Ukryj zafakturowane',
    salesInvoices: 'Faktury sprzedaży (oryginały)',
    salesInvoicesCopies: 'Faktury sprzedaży (kopie)',
    contracts: 'Zlecenia',
    purchaseInvoices: 'Faktury zakupu',
    attachmentsTypes: 'Typy załączników',
  },
  finance: {
    purchaseInvoices: 'Faktury zakupu',
    salesInvoices: 'Faktury sprzedaży',
    FVS: 'FVS',
    FVZ: 'FVZ',
    budgetReport: 'Raport do budżetu',
    FVZDeficiencies: 'Braki zakupowe',
    salesInvoicing: 'Sprzedaż - zafakturowanie',
    estimates: 'Pozycje mediaplanu',
    controling: 'Kontroling',
    FVZWithEstimates: 'FVZ - przypisanie do pozycji mediaplanów',
    FVZWithEstimatesLong: 'Faktury zakupu w powiązaniu z pozycjami mediaplanów',
    FVZWithEstimatesShort: 'FVZ, pozycje mediaplanu',
    FVSControling: 'FVS - raport dla kontrolingu',
    FVSControlingLong: 'Faktury sprzedaży w podziale na miesiąc dowiązania',
    FVSControlingShort: 'FVS, pozycje mediaplanu',
    reportFVS: 'RaportFVS',
    reportFVZ: 'RaportFVZ',
    reportFVSByMonth: 'Zestawienie faktur sprzedaży w kontekście miesięcy',
    reportFVZLong: 'Zestawienie faktur zakupu',
    reportFVZByPosition:
      'Zestawienie faktur zakupu w kontekście pozycji mediaplanu',
    reportControlFVZ: 'RaportKontrolingFVZ',
    reportControlFVS: 'RaportKontrolingFVS',
    reportToBudget: 'RaportDoBudzetu',
    reportFVSLong: 'Zestawienie faktur sprzedaży',
    reportFVSWithPositions: 'Zestawienie faktur sprzedaży z nazwami pozycji',
    yearType: 'Filtr ',
    reportFVZDeficiencies: 'BrakiFVZ',
    reportFVZDeficienciesLong: 'Raport braków FVZ w pozycjach',
    reportSalesInvoicingLong: 'Raport sprzedaż - zafakturowanie',
    reportProjectReadyToInvoiceTitle: 'Gotowe_do_fakturowania',
    FVSEstimateItems: 'Pozycje mediaplanów - powiązania z FVS',
    FVSEstimateItemsLong:
      'Pozycje mediaplanów w powiązaniu z fakturami sprzedaży',
    FVSEstimateItemsShort: 'Pozycje mediaplanu, FVS',
    reportFVSEstimateItems: 'ZestawienieFVSPozycje',
    reportFVSEstimateItemsTitle:
      'Pozycje mediaplanów - powiązania z fakturami sprzedaży',
  },
  administration: {
    estimatesPositions: 'Pozycje mediaplanów',
    rawData: 'Surówka',
    contracts: 'Zlecenia',
    clients: 'Kontrahenci',
    contractsMonitoring:
      'Monitoring adopcji i jakości procesowej modułu zleceń',
    contractsMonitoringShort: 'Monitoring zleceń',
    contractsMonitoringFile: 'MonitoringZlecen',
    clientsContacts: 'Zestawienie kontaktów kontrahentów',
    clientsContactsShort: 'Kontakty kontrahentów',
    clientsContactsFile: 'KontaktyKontrahentow',
    extensiveDataFromEstimatesByMonth: 'Rozbudowane dane z pozycji mediaplanów',
    documents: 'Dokumenty',
    files: 'Pliki',
  },
  controlling: {
    positionName: 'Pozycja nazwa',
    clientName: 'Pozycja kontrahent',
    format: 'Format',
    salesNet: 'Sprzedaż netto',
    salesCommissionAmount: 'Sprzedaż prowizja kwota',
    salesNetTotal: 'Sprzedaż total netto',
    mpSigned: 'MP podpisany',
    attachmentOrder: 'Zlecenie do dostawcy',
    acceptedOrderExec: 'Zaakceptowana realizacja zamówienia',
    clientFV: 'FV od dostawcy',
    noPositions: 'Brak pozycji do wyświetlenia',
    control: 'Kontrola',
    genitiveDocuments: 'dokumentow',
    documentList: 'Zestawienie do kontroli dokumentów',
    for: 'dla',
    documentControl: 'Kontrola dokumentów',
  },
} as const;
